export const NEXT_AVAILABLE_TEST_ATTEMPT_DAYS = 7;
export const NEXT_AVAILABLE_TEST_ATTEMPT_SECONDS = 60*60*24*7; // 604800

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  let errorMessage = null;

  if (!rules) {
    return {
      isValid: true,
      errorMessage: null
    };
  }

  value = value ? value : '';

  if (rules.required) {
    isValid = value.trim() !== '' && isValid;
    errorMessage = !isValid ? 'Ovo polje je obavezno' : null;
    if (rules.exact) {
      isValid = value.length === rules.exact && isValid;
      errorMessage = (errorMessage === null) ? (!isValid ? 'Ovo polje treba da ima ' + rules.exact + ' karaktera' : null) : errorMessage;
    }
    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
      errorMessage = (errorMessage === null) ? (!isValid ? 'Ovo polje treba da ima najmanje ' + rules.minLength + ' karaktera' : null) : errorMessage;
    }
    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
      errorMessage = (errorMessage === null) ? (!isValid ? 'Ovo polje treba da ima najviše ' + rules.minLength + ' karaktera' : null) : errorMessage;
    }
    if (rules.isEmail) {
      const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      isValid = pattern.test(value) && isValid;
      errorMessage = (errorMessage === null) ? (!isValid ? 'Pogrešan format email adrese' : null) : errorMessage;
    }
    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
      errorMessage = (errorMessage === null) ? (!isValid ? 'Ovo polje treba da bude u formatu broja' : null) : errorMessage;
    }
  }
  return {
    isValid: isValid,
    errorMessage: errorMessage
  };
};

export const inputChangedFunction = (value, inputIdentifier, state) => {

  const validity = checkValidity( value, state.form[inputIdentifier].validation);
  let fieldObject = {
    value: value,
    valid: validity.isValid,
    errorMessage: validity.errorMessage,
    touched: true
  };

  const updatedFormElement = updateObject(state.form[inputIdentifier], fieldObject);

  const updatedForm = updateObject(state.form, {
    [inputIdentifier]: updatedFormElement
  });

  let formIsValid = true;
  for (let inputIdentifier in updatedForm) {
    formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    //console.log('formIsValid', inputIdentifier, updatedForm[inputIdentifier].valid, formIsValid);
  }
  //console.log('inputChangedFunction updatedForm: ', updatedForm, 'form is valid: ', formIsValid);
  return {
    form: updatedForm,
    formIsValid: formIsValid
  };
};

export const checkAxiosErrorFields = (errorFields, state) => {
  let newState = {
    ...state
  };
  Object.keys(errorFields).map(key => {
    const updatedFormElement = updateObject(newState.form[key], {
      errorMessage: errorFields[key],
      valid: false,
      touched: true
    });
    const updatedForm = updateObject(newState.form, {
      [key]: updatedFormElement
    });
    let formIsValid = true;
    for (let key in updatedForm) {
      formIsValid = updatedForm[key].valid && formIsValid;
    }
    newState.form = updatedForm;
    newState.formIsValid = formIsValid;
    //console.log('errorFields', key, errorFields[key], updatedFormElement, updatedForm, newState);
  });
  return newState;
};

export const formatStateForForm = (form) => {
  let formElementsArray = [];
  for (let key in form) {
    formElementsArray[form[key]['order']] = {
      id: key,
      config: form[key]
    };
  }
  return formElementsArray;
};

export const formatUserForForm = (state, propsUser) => {
  const stateArray = formatStateForForm(state.form);
  let newState = {
    ...state
  };
  for (const item of stateArray) {
    const newValue = (item.id === 'country') ? propsUser[item.id].id : propsUser[item.id];
    newState = inputChangedFunction(newValue, item.id, newState);
  }
  return newState;
};

export const formatDate = date => {
  const month = date.getMonth();
  const formatedMonth = ((month < 9) ? '0' : '') + (month + 1);
  const day = date.getDate();
  const formatedDay = ((day < 10) ? '0' : '') + day;
  return formatedDay + '.' + formatedMonth + '.' + date.getFullYear() + '.';
};
export const formatTime = seconds => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.round(seconds % 60);
  return [
    h,
    m > 9 ? m : (h ? '0' + m : m || '0'),
    s > 9 ? s : '0' + s
  ].filter(Boolean).join(':');
};

export const formatSecondsToHours = seconds => {
  return (parseInt(seconds)/3600).toFixed(0)
};
export const formatSecondsToDays = seconds => {
  return (parseInt(seconds)/(3600*24)).toFixed(0)
};

export const differenceFromToday = (datum) => {
  const date = new Date(datum);
  const today = new Date();
  // There is a potential bug with local date time.
  // Workaround is to add/remove 3600 sec, but permanent solution should be find.
  return ((date - today)/1000).toFixed(0);
};

export const differenceDates = (minuend, subtrahend) => {
  const minuendDate = new Date(minuend);
  const subtrahendDate = new Date(subtrahend);
  return ((minuendDate - subtrahendDate)/(1000*60*60*24)).toFixed(0);
};

export const countModulesandLessons = (courseModules) => {
  let modules = courseModules.length,
    lessons = 0;

  if (modules > 0) {
    lessons = Object.keys(courseModules).map(key => {
      return courseModules[key].lessons.length;
    }).reduce((acc, el) => acc + el, 0);
  }

  return {
    modules: modules,
    lessons: lessons
  }
};

export const getAxiosHeader = () => {
  let headers = {};
  if (localStorage.getItem('token')) {
    const AuthStr = 'Bearer ' + (localStorage.getItem('token'));
    headers = {
      'headers': { 'Authorization': AuthStr }
    };
  }
  return headers;
};

export const getNextLesson = (slug, courseModules) => {
  let prevLesson = false;
  let nextLesson = null;
  for (let [keyModule, module] of Object.entries(courseModules)) {
    for (let [keyLesson, lesson] of Object.entries(module.lessons)) {
      if (prevLesson) {
        //console.log('Next lesson', lesson.slug);
        nextLesson = lesson.slug;
        prevLesson = false;
      }
      if(lesson.slug === slug) {
        //console.log('Prev lesson', lesson.slug, slug);
        prevLesson = true;
      }
    }
  }
  return nextLesson;
};

/***************************/
/* Plural/Singular strings */
/***************************/
export const getLessonString = (lessonCount) => {
  return (lessonCount % 10 > 1 && lessonCount % 10 < 5 && !(lessonCount > 11 && lessonCount < 15)) ? "lekcije" : "lekcija";
};
export const getDayString = (number) => {
  return ((number % 10) === 1  && number !== 11) ? "dan" : "dana";
};
export const getHourString = (number) => {
  return (number % 10 === 1 && number !== 11) ? "sat" : ((number % 10 > 1 && number % 10 < 5 && !(number > 11 && number < 15)) ? "sata" : "sati");
};
export const getMinuteString = (number) => {
  return ((number % 10) === 1) ? "minut" : "minuta";
};
export const getSecondString = (number) => {
  return "sek.";
};
export const getFreeAttemptsString = (number) => {
  return (number % 10 === 1 && number !== 11) ? "besplatan pokušaj" : ((number % 10 > 1 && number % 10 < 5 && !(number > 11 && number < 15)) ? "besplatna pokušaja" : "besplatnih pokušaja");
};
export const getCourseString = (number) => {
  return ((number % 10) === 1) ? "kurs" : ([2,3,4].includes(number) ? "kursa" : "kurseva");
};

/**********************************/
/* Prepare Mailchimp Url for AJAX */
/**********************************/
export const getMailchimpAjaxUrl = (url) => {
  return url.replace("/post?", "/post-json?");
};

export const getTestAttemptRemainingTime = (startTime, duration) => {
  const passedTime = parseInt(differenceFromToday(startTime));
  return parseInt(duration) + passedTime;
};

/************************/
/* Lesson URL generator */
/************************/
export const lessonUrlGenerator = (course, lesson) => {
  return /kurs/ + course + '/lekcija/' + lesson;
};

export const setPlainPasswordAsOptionalField = (state) => {
  const newValidation = updateObject(state.form.plainPassword.validation, {
    required: false
  });
  const newPlainPassword = updateObject(state.form.plainPassword, {
    validation: newValidation,
    valid: true
  });
  const newForm = updateObject(state.form, {
    plainPassword: newPlainPassword
  });
  return updateObject(state, {
    form: newForm
  });
};